import Select from "../../../../../components/Select";
import Button from "../../../../../components/Button";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import { IOption } from "../../../../../models/Form";
import { useEffect, useState } from "react";

const FRTypeFilterDropdown = ({
  frTypeOptions,
  handleOnChange,
  handleResetClick = () => {},
  style,
  clearFilter = false,
  value
}: {
  frTypeOptions: IOption[];
  handleOnChange: (selectedFrType: IOption) => void;
  handleResetClick?: () => void;
  style?: Record<any, any>;
  clearFilter?: boolean;
  value?: string | null;
}) => {
  const [frType, setFrType] = useState<IOption>();
  const [showResetButton, setShowResetButton] = useState(clearFilter);

  useEffect(() => {
    if (clearFilter) {
      setShowResetButton(true);
    } else {
      setShowResetButton(false);
      setFrType(undefined);
    }
  }, [clearFilter]);

  useEffect(() => {
    const frTypeOption = frTypeOptions.find((frType) => frType.value === value);
    if (frTypeOption) {
      setFrType(frTypeOption);
      setShowResetButton(true);
    }
  }, [value]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flex: "0.5 1",
        ...style
      }}>
      <Select
        style={{ flex: "1 1" }}
        value={frType}
        options={frTypeOptions}
        placeholder="Filter by funding request type"
        onChange={(selectFrType) => {
          setFrType(selectFrType);
          handleOnChange(selectFrType);
          setShowResetButton(true);
        }}
      />
      {showResetButton && (
        <Button
          style={{
            marginLeft: "0.75rem",
            boxSizing: "border-box",
            display: "flex",
            height: "3.1rem",
            flexDirection: "column"
          }}
          variant="outline"
          iconButton
          onClick={() => {
            handleResetClick();
            setFrType(undefined);
            setShowResetButton(false);
          }}>
          <Icon path={mdiClose} className="m-auto size-5" />
        </Button>
      )}
    </div>
  );
};

export default FRTypeFilterDropdown;
